import {Injectable} from '@angular/core';
import {CommonService} from "../../../shared/services/common.service";
import {Observable} from "rxjs";
import {GroupOptionsModel} from "../models/group-options.model";
import {ClientOptionsModel} from "../models/client-options.model";
import {InviteUserModel} from "../models/invite-user.model";
import {v1URL} from "../../../shared/constants/urls.constants";
import {
  ParticipantUsernameFilter
} from "../models/participant-username-filter.model";
import {AdultUsernameFilter} from "../models/adult-username-filter.model";
import {HasAssociatedLarModel} from "../models/has-associated-lar.model";
import {
  FetchEmailPreviewDataModel
} from "../models/fetch-email-preview-data.model";

@Injectable({
  providedIn: 'root',
})

export class InviteService {
  constructor(
    private commonServices: CommonService
  ) {
  }

  fetchGroupsFilter(payload?: GroupOptionsModel['request']): Observable<GroupOptionsModel['response']> {
    const urlConfig = v1URL.filters.groups
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchClientsFilter(payload): Observable<ClientOptionsModel['response']> {
    const urlConfig = v1URL.filters.clients
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  invite(payload): Observable<InviteUserModel["response"]> {
    const urlConfig = v1URL.user.invite['send-invite']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchParticipantUsernameFilter(payload): Observable<ParticipantUsernameFilter["response"]> {
    const urlConfig = v1URL.filters.participantUsernames
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchAdultUsernameFilter(payload): Observable<AdultUsernameFilter["response"]> {
    const urlConfig = v1URL.filters.adultUsernames
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  hasAssociatedLar(payload): Observable<HasAssociatedLarModel["response"]> {
    const urlConfig = v1URL.username.hasAssociatedLar
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  releaseUsername(payload): Observable<any> {
    const urlConfig = v1URL.username.release
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchEmailPreviewData(payload): Observable<FetchEmailPreviewDataModel['response']> {
    const urlConfig = v1URL.user.invite.preview
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchPreviewInviteData(payload): Observable<FetchEmailPreviewDataModel['response']> {
    const urlConfig = v1URL.user.invite.previewInvite
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }


}
